
import React, { useState, useEffect } from "react";
import "./overviewNotification.css";
import { connect } from "react-redux";
import ParentHeader from "../parentHeader/ParentHeader";
import LoaderPopUp from "../../components/loader/loader";
import images from "../../utilities/images/images";
import axios from "axios";
import uiActions from "../../redux/ui/action";
import { formatDistanceToNow } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

function OverviewNotification(props) {
  const { loginFromParent, loader, startLoading, finishLoading, rollNo } = props;

  const [notifications, setNotifications] = useState([]);

  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
  );
  const [endDate, setEndDate] = useState(new Date());

  const fetchNotifications = async (start, end) => {
    if (!rollNo) return;

    startLoading();
    try {
      const response = await axios.post(
        "https://bg.mescray001.com/api/v1/attendance-service/get-user-noti-datewise",
        {
          startDate: start.toISOString().split("T")[0],
          endDate: end.toISOString().split("T")[0],
          rollNo: rollNo,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setNotifications(response.data.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      finishLoading();
    }
  };

  useEffect(() => {
    fetchNotifications(startDate, endDate);
  }, []);

  const handleDateFilter = () => {
    if (startDate > endDate) {
      alert("Start date cannot be after end date.");
      return;
    }
    fetchNotifications(startDate, endDate);
  };

  return (
    <>
      {loginFromParent && <ParentHeader />}
      <div className="overview-notification-container">
        <div className="overview-notification-topbar">
          <div className="topbar-main">
            <Link to="/parent-dashboard" className="back-btn-link">
              <img src={images.m2_backBtn} alt="backbutton" className="back-arrow" />
            </Link>
            <div className="overview-notification-message">Notifications</div>
          </div>

          <div className="date-range-controls">
            <p>Search By Specific Date</p>
            <div className="date-input">
              <label>From</label>
              <DatePicker
                className="datepicker"
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={5}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </div>
            <div className="date-input">
              <label>To</label>
              <DatePicker
                className="datepicker"
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                maxDate={new Date()}
              />
            </div>
            <button className="filter-button" onClick={handleDateFilter}>
              Continue
            </button>
          </div>
        </div>

        {loader ? (
          <LoaderPopUp />
        ) : notifications.length > 0 ? (
          notifications.map((item) =>
            item.notification_description ? (
              <div
                key={item.notification_id}
                className="overview-notification-item"
              >
                <div className="overview-motion-logo">Motion</div>
                <div className="overview-notification-content">
                  <p className="overview-notification-text">
                    {item.notification_description}
                  </p>
                </div>
                <div className="overview-notification-time">
                  <p>
                    {item.created_at
                      ? formatDistanceToNow(new Date(item.created_at), {
                          addSuffix: true,
                        })
                      : "No date"}
                  </p>
                </div>
              </div>
            ) : null
          )
        ) : (
          <p className="no-notifications">No notifications found.</p>
        )}
      </div>
    </>
  );
}

// Redux setup
const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
  rollNo:
    state.parentrootReducer.parentAuthReducer.user?.st_rollno ||
    state.auth.user?.roll_no ||
    "",
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OverviewNotification);
